import ApplicationsView from "@/systems/modules/applications/ApplicationsView.vue";
import ApplicationCategoriesView from "@/systems/modules/applications/ApplicationCategoriesView.vue";
import ApplicationCategoryQuestionsView from "@/systems/modules/applications/ApplicationCategoryQuestionsView.vue";
import ApplicationBansPage from "@/systems/modules/applications/ApplicationBansPage.vue";
import {RouterView} from "vue-router";
import authorization from "@/authorization";
import ApplicationCategoryHeaderView from "@/systems/modules/applications/ApplicationCategoryHeaderView.vue";
import ApplicationsHeaderView from "@/systems/modules/applications/ApplicationsHeaderView.vue";
import PlayerApplicationsView from "@/systems/modules/applications/PlayerApplicationsView.vue";
import {modules} from "@/systems/modules/modules";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "community.modules.applications",
            path: "applications",
            component: ApplicationsHeaderView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled("applications") && (authorization.permission("modules.applications.categories.edit") || authorization.permission("modules.applications.applications.answer") || authorization.resourceTypePermission("modules.applications.category", "applications.answer") || authorization.resourceTypePermission("modules.applications.category", "status.change") || authorization.resourceTypePermission("modules.applications.category", "questions.edit"))
            },
            redirect: { name: "community.modules.applications.categories" },
            children: [
                {
                    path: "categories",
                    component: RouterView,
                    props: true,
                    children: [
                        {
                            name: "community.modules.applications.categories",
                            path: "",
                            component: ApplicationCategoriesView,
                            props: true
                        }
                    ]
                },
                {
                    name: "community.modules.applications.bans",
                    path: "bans",
                    component: ApplicationBansPage,
                    props: true,
                    meta: {
                        title: "bans",
                        icon: "fas fa-ban text-danger",
                        authorize: () => authorization.permission("modules.applications.bans.edit"),
                    }
                }
            ]
        },
        {
            name: "community.modules.applications.category",
            path: "categories/:categoryId",
            component: ApplicationCategoryHeaderView,
            props: true,
            redirect: { name: "community.modules.applications.category.applications" },
            children: [
                {
                    name: "community.modules.applications.category.applications",
                    path: "applications",
                    component: ApplicationsView,
                    props: true
                },
                {
                    name: "community.modules.applications.category.questions",
                    path: "questions",
                    component: ApplicationCategoryQuestionsView,
                    props: true,
                    meta: {
                        title: "questions",
                        icon: "fas fa-question-circle text-info",
                        authorize: route => authorization.permission("modules.applications.categories.edit") || authorization.resourcePermission("modules.applications.category", route.params.categoryId,"questions.edit")
                    }
                }
            ]
        },
    ]),
    getPlayerRoutes: () => ([
        {
            name: "player.modules.applications",
            path: "applications",
            component: PlayerApplicationsView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.applications) && authorization.permission("modules.applications.applications.answer")
            }
        },
    ])
};